import { DisplayHeading } from '../../../typography/DisplayHeading';
import { BodyText } from '../../../typography/BodyText';

type ProductChoicesHeaderProps = {
  numProductChoices: number;
};

export const ProductChoicesHeader = ({ numProductChoices }: ProductChoicesHeaderProps) => {
  return (
    <div>
      <DisplayHeading className="mb-4" size="3" as="h2">
        Great choices within this collection
      </DisplayHeading>
      <BodyText className="text-neutral text-base font-normal leading-relaxed" as="div">
        Yes, there&apos;s plenty to see here. Take your pick of{' '}
        <b data-testid="product-choices-count">{numProductChoices} experiences.</b> You can start
        exploring them below.
      </BodyText>
    </div>
  );
};
